
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-print-outline)"}},[_c('path',{attrs:{"d":"M13.656 4.531h-.437V2.844A2.346 2.346 0 0010.875.5h-5.75a2.346 2.346 0 00-2.344 2.344V4.53h-.437A2.346 2.346 0 000 6.875v3.75a2.346 2.346 0 002.344 2.344h.437v2.125c0 .775.631 1.406 1.406 1.406h7.625c.776 0 1.407-.63 1.407-1.406v-2.125h.437A2.346 2.346 0 0016 10.625v-3.75a2.346 2.346 0 00-2.344-2.344zM3.72 2.844c0-.776.63-1.406 1.406-1.406h5.75c.775 0 1.406.63 1.406 1.406V4.53H3.72V2.844zm8.562 12.25a.47.47 0 01-.469.469H4.189a.47.47 0 01-.47-.47V10.47h8.563v4.625zm2.781-4.469c0 .775-.63 1.406-1.406 1.406h-.437V10.47h.281a.469.469 0 000-.938h-11a.469.469 0 000 .938h.281v1.562h-.437c-.776 0-1.406-.63-1.406-1.406v-3.75c0-.775.63-1.406 1.406-1.406h11.312c.776 0 1.406.63 1.406 1.406v3.75z"}}),_c('path',{attrs:{"d":"M9.25 11.531h-2.5a.469.469 0 000 .938h2.5a.469.469 0 000-.938zM9.25 13.531h-2.5a.469.469 0 000 .938h2.5a.469.469 0 000-.938zM4 6.531H2.5a.469.469 0 000 .938H4a.469.469 0 000-.938z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-print-outline"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    